import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { COMPANY_TYPE } from 'app/mock/mock-company-type-list';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-companyDetail',
  templateUrl: './companyDetail.component.html',
  styleUrls: ['./companyDetail.component.css']
})
export class CompanyDetailComponent implements OnInit {

  submitted = false;
  error = false;
  success = false;
  registrationCompanyDetailForm: FormGroup;
  registerId: any;
  getCompanyData: any;
  checkIfUserAlreadyExist = false;
  confirmPasswordCheck = false;
  companyTypeList = [];

  constructor(
    private activatedRouter: ActivatedRoute, 
    private formBuilder: FormBuilder, 
    private registerService: RegisterService, 
    private commonUtilService: CommonUtilService,
    private router: Router,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();

    this.companyTypeList = COMPANY_TYPE;

    this.registerId = this.activatedRouter.snapshot.paramMap.get("registerId");
    this.registrationCompanyDetailForm = this.registrationCompanyDetailFormBuilder(this.formBuilder);

    this.registerService.getUserPersonalDetail(this.registerId).subscribe(data => {
      if(data == null){
        this.goToPersonalDetail();
      } else {
        this.registerService.getUserCompanyDetail(this.registerId).subscribe(data => {
          if(data){
            this.getCompanyData = data;
            this.registrationCompanyDetailForm = this.registrationCompanyDetailFormBuilder(this.formBuilder);
          }
        });
      }
    });
    this.spinnerService.stop();
  }

  // convenience getter for easy access to form fields
  get f() { return this.registrationCompanyDetailForm.controls; }
  // convenience getter for easy access to form fields
  get val() { return this.registrationCompanyDetailForm.value; }

  // form builder service create form group instances
  registrationCompanyDetailFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      businessName: [this.getCompanyData && this.getCompanyData.businessName ? this.getCompanyData.businessName : '', [Validators.required]],
      vatNumber: [this.getCompanyData && this.getCompanyData.vatNumber ? this.getCompanyData.vatNumber : '', [Validators.required, Validators.pattern('^\\d{11}$')]],
      typeOfCompany: [this.getCompanyData && this.getCompanyData.typeOfCompany ? this.getCompanyData.typeOfCompany : '', [Validators.required]],
      businessEmail: [this.getCompanyData && this.getCompanyData.businessEmail && this.getCompanyData.businessEmail.email ? this.getCompanyData.businessEmail.email : '', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      companyPec: [this.getCompanyData && this.getCompanyData.businessEmailPec && this.getCompanyData.businessEmailPec.email ? this.getCompanyData.businessEmailPec.email : '', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      companyResidenceVia: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.street ? this.getCompanyData.address.street : '', [Validators.required]],
      companyResidenceNCivic: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.houseNumber ? this.getCompanyData.address.houseNumber : '', [Validators.required]],
      companyResidenceCity: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.city ? this.getCompanyData.address.city : '', [Validators.required]],
      companyResidenceProvince: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.district ? this.getCompanyData.address.district : '', [Validators.required]],
      companyResidenceCountry: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.country ? this.getCompanyData.address.country : '', [Validators.required]]
    });
  }

  onSubmit() {
    this.spinnerService.start();
    this.submitted = true;
    this.error = false;

    if (this.registrationCompanyDetailForm.invalid) {
      return;
    }

    var companyDetail = {
      businessName: this.val.businessName,
      vatNumber: this.val.vatNumber,
      typeOfCompany: this.val.typeOfCompany,
      businessEmail: {
        email: this.val.businessEmail
      },
      businessEmailPec: {
        email: this.val.companyPec
      },
      address: {
        street: this.val.companyResidenceVia,
        houseNumber: this.val.companyResidenceNCivic,
        city: this.val.companyResidenceCity,
        district: this.val.companyResidenceProvince,
        country: this.val.companyResidenceCountry
      }
    };

    this.registerService.addUserCompanyDetail(this.registerId, companyDetail).subscribe(data => {
      this.goToSummary();
    }, err => {
      this.error = true;
      this.spinnerService.stop();
      setTimeout(()=>{                           
        this.error = false;
      }, 2000);
    });
  }

  goToSummary(){
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/summary']);
  }

  goToPersonalDetail(){
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/personalDetail']);
  }
}
